import {
  LOGIN,
} from "../api.config";
import { postAPI } from "library/helpers/api";

export function login(header, params) {
  return postAPI(LOGIN, header, params);
}
